export default {
  countCells: 14,
  massive: [
    {
      dataField: 'actions',
      cols: 1,
      rows: 1,
      text: '',
      class: 'd-flex flex-row align-center justify-center ',
      styles: 'flex-basis: 50px',
      order: 0,
      variable: true,
    },
    {
      dataField: 'npg',
      cols: 4,
      rows: 1,
      class: 'justify-start d-flex flex-row',
      text: `УГСН `,
      order: 6,
      variable: true,
      template: (row) => {
        return row.sprKcpGroupId + ' - ' + row.sprKcpGroupName
      }
    },
    {
      dataField: 'isAccred',
      cols: 2,
      rows: 1,
      text: `Наличие действующей аккредитации`,
      class: 'd-flex flex-row justify-center',
      order: 7,
      variable: true,
    },
    {
      dataField: 'gasnm',
      cols: 1,
      rows: 1,
      text: `Регистрационный номер`,
      order: 8,
      variable: true,
    },
    {
      dataField: 'gadtb',
      cols: 1,
      rows: 1,
      text: `Дата выдачи`,
      order: 10,
      variable: true,
      typeValue: 'date',
    },
    {
      dataField: 'gadte',
      cols: 1,
      rows: 1,
      text: `Дата окончания действия`,
      order: 10,
      variable: true,
      typeValue: 'date',
      template: (row) => {
        return row.gadte !== null ? row.gadte : 'бессрочно'
      }
    },
    {
      dataField: 'gaypa',
      cols: 2,
      rows: 1,
      text: `Год первичного обязательства в получении аккредитации`,
      html: `Год первичного обяза<br>-тельства в получении<br> аккредитации`,
      order: 11,
      variable: true,
    },
    {
      dataField: 'gatxt',
      cols: 2,
      rows: 1,
      text: `Комментарии`,
      order: 12,
      variable: true,
      class: 'd-flex  justify-center',
      styles: 'justify-content: unset; text-align: center;',
    },
  ]
}
export const headerForDialog = [
  {
    "text": "УГСН",
    "dataField": "idSprKcpUgs",
    "typeVar": "selector",
    "variableName": 'idSprKcpUgs',
    "sprDataName": 'sprKcpUgs',
    "rules": 3,
    "order": 0,
  },
  {
    "text": "Наличие аккредитации",
    "dataField": "isAccred",
    "typeVar": "checkbox",
    "rules": 3,
    "order": 0,
  },
  {
    "text": "Регистрационный номер",
    "dataField": "gasnm",
    "typeVar": "string",
    "rules": 3,
    "customsRulesArray": [
      v => !!v || 'введите значение',
    ],
    dependence: true,
    dependenceDataField: "isAccred",
    dependenceValueActive: [true],
    "order": 1,
  },
  {
    "text": "Дата выдачи",
    "dataField": "gadtb",
    "typeVar": "date",
    dependence: true,
    dependenceDataField: "isAccred",
    dependenceValueActive: [true],
    "rules": 3,
    "order": 2,
  },
  {
    "text": "Бессрочно",
    "dataField": "isEndless",
    "typeVar": "checkbox",
    dependence: true,
    dependenceDataField: "isAccred",
    dependenceValueActive: [true],
    "rules": 3,
    "order": 3,
  },
  {
    "text": "Дата окончания действия ",
    "dataField": "gadte",
    "typeVar": "date",
    dependence: true,
    dependenceDataField: "isAccred",
    dependenceValueActive: [true],
    "rules": 3,
    "order": 4,
  },
  {
    "text": "Год первичного обязательства в получении аккредитации\n",
    "dataField": "gaypa",
    "typeVar": "selector",
    "variableName": 'gaypa',
    "sprDataName": 'sprGaypa',
    type: 'number',
    "rules": 3,
    "customsRulesArray": [
      v => !!v || 'введите значение',
    ],
    dependence: true,
    dependenceDataField: "isAccred",
    dependenceValueActive: [false],
    "order": 5,
  },
  {
    "text": `Комментарии`,
    "dataField": "gatxt",
    "typeVar": "textarea",
    "rules": 1,
    "order": 6,
  },
]
